/* Publish by EComposer at 2026-11-02 07:18:22*/
;try{
 /* ===== Mercure r\u00e9trograde \u2014 Astroya \u2014 JS ES5 (bloc s\u00e9par\u00e9) ===== */
(function () {
  'use strict';
  var root = document.getElementById('mrx');
  if (!root) { return; }
  root.className += ' mrx-js';

  /* ---------- Utilitaires ---------- */
  var LS = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  function $(id) { return document.getElementById(id); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function D(s) {
    var p = s.split(/[-T:]/);
    return new Date(+p[0], +p[1] - 1, +p[2], p[3] ? +p[3] : 0, p[4] ? +p[4] : 0);
  }
  var MOIS = ['janvier', 'f\u00e9vrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'ao\u00fbt', 'septembre', 'octobre', 'novembre', 'd\u00e9cembre'];
  function fmt(d) { return (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear(); }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Son & vibrations ---------- */
  var sndOn = LS.get('mrx_snd') !== '0';
  var hapOn = LS.get('mrx_hap') !== '0';
  var AC = null;
  function ac() {
    if (!sndOn) { return null; }
    if (!AC) {
      var C = window.AudioContext || window.webkitAudioContext;
      if (!C) { return null; }
      try { AC = new C(); } catch (e) { return null; }
    }
    if (AC.state === 'suspended' && AC.resume) { AC.resume(); }
    return AC;
  }
  function tone(f, dur, type, vol, slideTo, delay) {
    var a = ac(); if (!a) { return; }
    var t = a.currentTime + (delay || 0);
    var o = a.createOscillator(), g = a.createGain();
    o.type = type || 'sine';
    o.frequency.setValueAtTime(f, t);
    if (slideTo) { o.frequency.exponentialRampToValueAtTime(slideTo, t + dur); }
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(vol || 0.06, t + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(a.destination);
    o.start(t); o.stop(t + dur + 0.05);
  }
  function buzz(p) {
    if (hapOn && navigator.vibrate) { try { navigator.vibrate(p); } catch (e) {} }
  }
  var SC = [523.25, 587.33, 659.25, 783.99, 880, 1046.5, 1174.66, 1318.51, 1567.98];
  function sfxTick() { tone(1250, 0.07, 'sine', 0.02); }
  function sfxHit(c, perfect) {
    var f = SC[Math.min(c - 1, SC.length - 1)];
    tone(f, 0.35, 'sine', 0.06);
    tone(f * 2, 0.22, 'triangle', 0.015, null, 0.02);
    if (perfect) { tone(f * 1.5, 0.45, 'sine', 0.04, null, 0.09); }
  }
  function sfxMiss() { tone(196, 0.38, 'triangle', 0.07, 98); }
  function sfxRetro() { tone(1100, 0.7, 'sine', 0.04, 260); tone(550, 0.7, 'triangle', 0.02, 130, 0.06); }
  function sfxStart() { var n = [523.25, 659.25, 783.99, 1046.5], i; for (i = 0; i < n.length; i++) { tone(n[i], 0.3, 'sine', 0.045, null, i * 0.09); } }
  function sfxEnd(win) {
    var n = win ? [783.99, 987.77, 1174.66, 1567.98] : [659.25, 523.25, 440, 349.23], i;
    for (i = 0; i < n.length; i++) { tone(n[i], 0.4, 'sine', 0.045, null, i * 0.12); }
  }

  function setToggle(btn, on) { if (btn) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); } }
  var bSnd = $('mrx-snd'), bHap = $('mrx-hap');
  setToggle(bSnd, sndOn); setToggle(bHap, hapOn);
  if (bSnd) { bSnd.onclick = function () { sndOn = !sndOn; LS.set('mrx_snd', sndOn ? '1' : '0'); setToggle(bSnd, sndOn); if (sndOn) { sfxTick(); } }; }
  if (bHap) { bHap.onclick = function () { hapOn = !hapOn; LS.set('mrx_hap', hapOn ? '1' : '0'); setToggle(bHap, hapOn); buzz(20); }; }

  /* ---------- Calendrier des r\u00e9trogradations (heure de Paris) ---------- */
  /* [d\u00e9but ombre, station r\u00e9trograde, station directe, fin ombre, signe] */
  var PH = [
    ['2026-02-11T23:13', '2026-02-26T07:48', '2026-03-20T12:00', '2026-04-09T23:59', 'Poissons'],
    ['2026-06-13T02:54', '2026-06-29T19:35', '2026-07-23T12:00', '2026-08-06T23:59', 'Cancer'],
    ['2026-10-04T11:12', '2026-10-24T09:12', '2026-11-13T16:53', '2026-11-29T23:59', 'Scorpion'],
    ['2027-01-25T12:00', '2027-02-09T19:36', '2027-03-03T14:32', '2027-03-23T23:59', 'Poissons'],
    ['2027-05-26T12:00', '2027-06-10T20:15', '2027-07-04T21:39', '2027-07-19T23:59', 'Cancer'],
    ['2027-09-17T12:00', '2027-10-07T16:37', '2027-10-28T16:10', '2027-11-13T23:59', 'Scorpion']
  ];
  var SIGNE_FIN = ['Poissons', 'Cancer', 'Scorpion', 'Verseau', 'G\u00e9meaux', 'Balance'];

  function getStatus(now) {
    var i, p, pre, rx, d, post, prevEnd = null;
    for (i = 0; i < PH.length; i++) {
      p = PH[i]; pre = D(p[0]); rx = D(p[1]); d = D(p[2]); post = D(p[3]);
      if (now < pre) { return { k: 'direct', i: i, from: prevEnd, to: rx, rx: rx, pre: pre }; }
      if (now < rx) { return { k: 'pre', i: i, from: pre, to: rx }; }
      if (now < d) { return { k: 'rx', i: i, from: rx, to: d, post: post }; }
      if (now < post) { return { k: 'post', i: i, from: d, to: post }; }
      prevEnd = post;
    }
    return { k: 'end' };
  }

  var elT = $('mrx-live-title'), elS = $('mrx-live-sub'), elL = $('mrx-cd-lab'), elDot = $('mrx-dot'), elBar = $('mrx-bar');
  var st = null;
  function renderStatus() {
    var now = new Date();
    st = getStatus(now);
    if (st.k === 'end' || !elT) { return; }
    var p = PH[st.i], sg = p[4];
    if (st.k === 'rx') {
      elT.textContent = 'Mercure est r\u00e9trograde en ' + sg + ' jusqu\u2019au ' + fmt(st.to);
      elS.textContent = 'Station directe le ' + fmt(st.to) + ', puis zone d\u2019ombre jusqu\u2019au ' + fmt(st.post) + '. Relis, sauvegarde, confirme.';
      elL.textContent = 'avant la station directe';
    } else if (st.k === 'pre') {
      elT.textContent = 'Mercure est dans sa zone d\u2019ombre d\u2019entr\u00e9e (' + sg + ')';
      elS.textContent = 'La r\u00e9trogradation commence le ' + fmt(st.to) + '. Anticipe : sauvegardes, confirmations, marges.';
      elL.textContent = 'avant la station r\u00e9trograde';
    } else if (st.k === 'post') {
      elT.textContent = 'Mercure est direct, mais encore dans sa zone d\u2019ombre';
      elS.textContent = 'Sortie compl\u00e8te de l\u2019ombre le ' + fmt(st.to) + '. Les dossiers en suspens se d\u00e9bloquent peu \u00e0 peu.';
      elL.textContent = 'avant la sortie de la zone d\u2019ombre';
    } else {
      elT.textContent = 'Mercure est direct : feu vert pour avancer';
      elS.textContent = 'Prochaine r\u00e9trogradation le ' + fmt(st.rx) + ' (' + sg + ' \u2192 ' + SIGNE_FIN[st.i] + '), zone d\u2019ombre d\u00e8s le ' + fmt(st.pre) + '.';
      elL.textContent = 'avant la prochaine r\u00e9trogradation';
    }
    if (st.i > 2 && st.k !== 'direct') { /* cycles 2027 : signe de d\u00e9part \u2192 signe d\u2019arriv\u00e9e */
      if (st.k === 'rx') { elT.textContent = 'Mercure est r\u00e9trograde (' + sg + ' \u2192 ' + SIGNE_FIN[st.i] + ') jusqu\u2019au ' + fmt(st.to); }
    }
    elDot.className = 'mrx-dot mrx-k-' + st.k;
    /* badges des cartes */
    var cards = root.querySelectorAll('.mrx-per'), j, c, idx, b, q;
    for (j = 0; j < cards.length; j++) {
      c = cards[j]; idx = +c.getAttribute('data-i'); b = c.querySelector('.mrx-badge');
      if (!b) { continue; }
      q = PH[idx];
      c.className = c.className.replace(/\s?mrx-now/g, '');
      if (now >= D(q[3])) { b.textContent = 'Termin\u00e9e'; b.className = 'mrx-badge'; }
      else if (now >= D(q[1]) && now < D(q[2])) { b.textContent = 'En cours'; b.className = 'mrx-badge mrx-b-rx'; c.className += ' mrx-now'; }
      else if (now >= D(q[0])) { b.textContent = 'Zone d\u2019ombre'; b.className = 'mrx-badge mrx-b-sh'; c.className += ' mrx-now'; }
      else if (st.i === idx) { b.textContent = 'Prochaine'; b.className = 'mrx-badge mrx-b-next'; }
      else { b.textContent = '\u00c0 venir'; b.className = 'mrx-badge'; }
    }
  }
  function tick() {
    if (!st || st.k === 'end') { return; }
    var now = new Date(), ms = st.to - now;
    if (ms <= 0) { renderStatus(); return; }
    var s = Math.floor(ms / 1000);
    $('mrx-cd-d').textContent = Math.floor(s / 86400);
    $('mrx-cd-h').textContent = pad(Math.floor((s % 86400) / 3600));
    $('mrx-cd-m').textContent = pad(Math.floor((s % 3600) / 60));
    $('mrx-cd-s').textContent = pad(s % 60);
    if (st.from && elBar) {
      var pct = Math.max(0, Math.min(100, (now - st.from) / (st.to - st.from) * 100));
      elBar.style.width = pct.toFixed(1) + '%';
    }
  }
  renderStatus(); tick();
  setInterval(tick, 1000);

  /* ---------- Export agenda (.ics) ---------- */
  function icsDate(d) { return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()); }
  function buildIcs() {
    var now = new Date(), out = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Astroya//Mercure retrograde//FR', 'CALSCALE:GREGORIAN'], i, p, end;
    for (i = 0; i < PH.length; i++) {
      p = PH[i];
      if (D(p[3]) < now) { continue; }
      end = D(p[2]); end.setDate(end.getDate() + 1);
      out.push('BEGIN:VEVENT', 'UID:mrx-' + i + '@astroya.fr', 'DTSTAMP:' + icsDate(now) + 'T000000Z',
        'DTSTART;VALUE=DATE:' + icsDate(D(p[1])), 'DTEND;VALUE=DATE:' + icsDate(end),
        'SUMMARY:\u263F Mercure r\u00e9trograde (' + p[4] + (i > 2 ? ' \u2192 ' + SIGNE_FIN[i] : '') + ')',
        'DESCRIPTION:Zone d\u2019ombre du ' + fmt(D(p[0])) + ' au ' + fmt(D(p[3])) + '. Conseils : https://www.astroya.fr/pages/mercure-retrograde',
        'BEGIN:VALARM', 'TRIGGER:-P1D', 'ACTION:DISPLAY', 'DESCRIPTION:Mercure r\u00e9trograde demain', 'END:VALARM',
        'END:VEVENT');
    }
    out.push('END:VCALENDAR');
    return out.join('\r\n');
  }
  var icsLinks = root.querySelectorAll('.mrx-ics'), k;
  for (k = 0; k < icsLinks.length; k++) {
    icsLinks[k].setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(buildIcs()));
    icsLinks[k].setAttribute('download', 'mercure-retrograde-astroya.ics');
    icsLinks[k].onclick = function () { buzz(25); sfxTick(); };
  }

  /* ---------- S\u00e9lecteur de signe ---------- */
  var sBtns = root.querySelectorAll('.mrx-sg');
  function showSign(key, silent) {
    var i, panels = root.querySelectorAll('.mrx-sp');
    for (i = 0; i < sBtns.length; i++) {
      var on = sBtns[i].getAttribute('data-s') === key;
      sBtns[i].className = 'mrx-sg' + (on ? ' mrx-act' : '');
      sBtns[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    for (i = 0; i < panels.length; i++) {
      panels[i].className = 'mrx-sp' + (panels[i].id === 'mrx-s-' + key ? ' mrx-act' : '');
    }
    if (!silent) { LS.set('mrx_sign', key); buzz(12); sfxTick(); }
  }
  for (k = 0; k < sBtns.length; k++) {
    sBtns[k].onclick = function () { showSign(this.getAttribute('data-s')); };
  }
  if (sBtns.length) { showSign(LS.get('mrx_sign') || 'scorpion', true); }

  /* ---------- FAQ : petit retour sensoriel ---------- */
  var dets = root.querySelectorAll('.mrx-faq details');
  for (k = 0; k < dets.length; k++) {
    dets[k].addEventListener('toggle', function () { if (this.open) { buzz(8); sfxTick(); } });
  }

  /* ---------- Apparition au scroll ---------- */
  var rv = root.querySelectorAll('.mrx-rv');
  if (reduced || !('IntersectionObserver' in window)) {
    for (k = 0; k < rv.length; k++) { rv[k].className += ' mrx-in'; }
  } else {
    var io = new IntersectionObserver(function (en) {
      var i;
      for (i = 0; i < en.length; i++) {
        if (en[i].isIntersecting) { en[i].target.className += ' mrx-in'; io.unobserve(en[i].target); }
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    for (k = 0; k < rv.length; k++) { io.observe(rv[k]); }
  }

  /* =====================================================================
     JEU DU MESSAGER
     ===================================================================== */
  var cv = $('mrx-cv');
  if (!cv || !cv.getContext) { return; }
  var ctx = cv.getContext('2d');
  var W = 360, cx = 180, cy = 180, R = 130, stars = [];
  var TAU = Math.PI * 2;

  function makeStars() {
    stars = [];
    var i;
    for (i = 0; i < 70; i++) {
      stars.push({ x: Math.random() * W, y: Math.random() * W, r: Math.random() * 1.3 + 0.3, t: Math.random() * TAU });
    }
  }
  function resize() {
    var w = cv.parentNode.clientWidth || 360;
    if (w > 420) { w = 420; }
    var dpr = window.devicePixelRatio || 1;
    cv.width = Math.round(w * dpr); cv.height = Math.round(w * dpr);
    cv.style.width = w + 'px'; cv.style.height = w + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    W = w; cx = cy = w / 2; R = w * 0.33;
    makeStars();
  }
  resize();
  window.addEventListener('resize', resize);

  function norm(a) { a = a % TAU; if (a < 0) { a += TAU; } return a; }
  function adiff(a, b) { var d = norm(a - b); if (d > Math.PI) { d -= TAU; } return d; }

  var G = { run: false, ang: -Math.PI / 2, spd: 1.7, dir: 1, tc: 0, hw: 0.55, score: 0, lives: 3, combo: 0, hits: 0,
    travel: 0, earth: 0, shake: 0, flash: 0, trail: [], parts: [], msg: '', msgT: 0, rings: [] };

  /* D\u00e9fi du jour & s\u00e9rie */
  var today = new Date();
  function dKey(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  var TK = dKey(today);
  var yest = new Date(today.getTime()); yest.setDate(yest.getDate() - 1);
  var dayNum = Math.floor(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) / 86400000);
  var GOAL = 8 + ((dayNum * 7) % 9);
  var best = +(LS.get('mrx_best') || 0);
  var streak = {};
  try { streak = JSON.parse(LS.get('mrx_streak') || '{}') || {}; } catch (e) { streak = {}; }
  if (streak.last && streak.last !== TK && streak.last !== dKey(yest)) { streak.n = 0; }

  function renderStreak() {
    var n = streak.n || 0, el = $('mrx-h-streak'), ss = $('mrx-stars'), i, it;
    if (el) { el.textContent = n; }
    if (ss) {
      it = ss.getElementsByTagName('i');
      var lit = n === 0 ? 0 : ((n - 1) % 7) + 1;
      for (i = 0; i < it.length; i++) { it[i].className = i < lit ? 'mrx-on' : ''; }
    }
  }
  function hud() {
    $('mrx-h-score').textContent = G.score;
    var h = '', i;
    for (i = 0; i < 3; i++) { h += i < G.lives ? '\u2665' : '\u2661'; }
    $('mrx-h-lives').textContent = h;
    $('mrx-h-best').textContent = Math.max(best, G.score);
    $('mrx-h-goal').textContent = (streak.done === TK ? '\u2713 ' : '') + GOAL;
  }
  hud(); renderStreak();

  function newTarget() {
    var off = Math.PI * (0.65 + Math.random() * 0.85);
    G.tc = norm(G.ang + G.dir * off);
    G.travel = 0;
  }
  function popMsg(t) { G.msg = t; G.msgT = 1.3; }
  function mPos() { return { x: cx + Math.cos(G.ang) * R, y: cy + Math.sin(G.ang) * R }; }
  function burst(perfect) {
    var p = mPos(), n = reduced ? 8 : (perfect ? 34 : 20), i, a, s;
    for (i = 0; i < n; i++) {
      a = Math.random() * TAU; s = 40 + Math.random() * (perfect ? 170 : 110);
      G.parts.push({ x: p.x, y: p.y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, l: 1, c: Math.random() < 0.5 ? '243,210,122' : (perfect ? '255,255,255' : '127,227,213'), r: 1 + Math.random() * 2.2 });
    }
    G.rings.push({ x: p.x, y: p.y, r: 6, l: 1 });
  }

  var ovStart = $('mrx-ov-start'), btnTap = $('mrx-tap'), res = $('mrx-res');

  function start() {
    ac();
    G.run = true; G.score = 0; G.lives = 3; G.combo = 0; G.hits = 0; G.spd = 1.7; G.hw = 0.55; G.dir = 1;
    G.ang = -Math.PI / 2; G.trail = []; G.parts = []; G.rings = [];
    newTarget(); hud();
    ovStart.className = 'mrx-ov mrx-hide';
    res.className = 'mrx-res';
    btnTap.className = 'mrx-tap';
    sfxStart(); buzz([15, 40, 15]);
    popMsg('Go !');
    try { cv.focus({ preventScroll: true }); } catch (e) {}
  }

  function retro() {
    G.dir = -G.dir; G.flash = 1;
    sfxRetro(); buzz([30, 45, 30, 45, 70]);
    popMsg(G.dir < 0 ? '\u263F R\u00e9trograde !' : '\u263F Station directe');
  }
  function hit(d) {
    var perfect = d < G.hw * 0.33, pts = perfect ? 3 : 1;
    G.combo++;
    if (G.combo >= 5) { pts += 1; }
    G.score += pts; G.hits++;
    burst(perfect); sfxHit(G.combo, perfect);
    buzz(perfect ? [12, 35, 18] : 18);
    popMsg(perfect ? 'Parfait ! +' + pts : (G.combo >= 5 ? 'Combo +' + pts : '+' + pts));
    G.hw = Math.max(0.17, G.hw * 0.95);
    G.spd = Math.min(4.3, G.spd * 1.045);
    if (G.hits % 5 === 0) { retro(); }
    newTarget(); hud();
  }
  function miss(t) {
    G.lives--; G.combo = 0; G.shake = 1;
    sfxMiss(); buzz(150);
    popMsg(t);
    hud();
    if (G.lives <= 0) { over(); } else { newTarget(); }
  }

  var RANKS = [
    [0, 'Apprenti messager'], [5, 'Messager ail\u00e9'], [10, 'Coursier des \u00e9toiles'],
    [18, 'Herm\u00e8s en sandales'], [28, 'Ma\u00eetre du carrefour'], [40, 'Gardien du caduc\u00e9e'], [60, 'Messager des dieux']
  ];

  function over() {
    G.run = false;
    btnTap.className = 'mrx-tap mrx-hide';
    var s = G.score, rk = RANKS[0][1], i, win = s >= GOAL, newBest = s > best;
    for (i = 0; i < RANKS.length; i++) { if (s >= RANKS[i][0]) { rk = RANKS[i][1]; } }
    if (newBest) { best = s; LS.set('mrx_best', '' + s); }
    var goalTxt;
    if (win && streak.done !== TK) {
      streak.n = (streak.last === dKey(yest)) ? (streak.n || 0) + 1 : 1;
      streak.last = TK; streak.done = TK;
      LS.set('mrx_streak', JSON.stringify(streak));
      goalTxt = '\u2728 D\u00e9fi du jour r\u00e9ussi ! Une nouvelle \u00e9toile s\u2019allume. Reviens demain pour la suivante.';
    } else if (win) {
      goalTxt = 'D\u00e9fi du jour d\u00e9j\u00e0 valid\u00e9. Reviens demain pour allumer l\u2019\u00e9toile suivante.';
    } else {
      goalTxt = 'D\u00e9fi du jour : ' + GOAL + ' messages. Encore ' + (GOAL - s) + ' pour allumer ton \u00e9toile !';
    }
    $('mrx-o-score').textContent = s + (s > 1 ? ' messages' : ' message');
    $('mrx-o-rank').textContent = rk + (newBest && s > 0 ? ' \u00b7 nouveau record !' : '');
    $('mrx-o-goal').textContent = goalTxt;
    var msgs = $('mrx-msgs') ? $('mrx-msgs').getElementsByTagName('li') : [];
    if (msgs.length) { $('mrx-o-msg').textContent = msgs[dayNum % msgs.length].textContent; }
    res.className = 'mrx-res mrx-show';
    ovStart.className = 'mrx-ov mrx-hide';
    hud(); renderStreak();
    sfxEnd(win); buzz(win ? [20, 60, 20, 60, 120] : [80, 60, 40]);
    if (win) { var j; for (j = 0; j < 3; j++) { G.ang = Math.random() * TAU; burst(true); } }
  }

  function tap(e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    if (!G.run) { return; }
    var d = Math.abs(adiff(G.ang, G.tc));
    if (d <= G.hw) { hit(d); } else { miss(d < G.hw * 1.6 ? 'Presque\u2026' : 'Hors de l\u2019arc'); }
  }

  $('mrx-go').onclick = start;
  $('mrx-again').onclick = start;
  btnTap.addEventListener(window.PointerEvent ? 'pointerdown' : 'touchstart', tap);
  if (!window.PointerEvent) { btnTap.addEventListener('mousedown', tap); }
  cv.addEventListener(window.PointerEvent ? 'pointerdown' : 'touchstart', function (e) { if (G.run) { tap(e); } });
  if (!window.PointerEvent) { cv.addEventListener('mousedown', function (e) { if (G.run) { tap(e); } }); }
  cv.addEventListener('keydown', function (e) {
    if (e.keyCode === 32 || e.keyCode === 13) { e.preventDefault(); if (G.run) { tap(); } else { start(); } }
  });

  $('mrx-share').onclick = function () {
    var txt = 'J\u2019ai transmis ' + G.score + ' messages au jeu du Messager de Mercure r\u00e9trograde. Tu fais mieux ? \u263F';
    var url = 'https://www.astroya.fr/pages/mercure-retrograde#mrx-jeu';
    buzz(15);
    if (navigator.share) { navigator.share({ title: 'Mercure r\u00e9trograde : le jeu du Messager', text: txt, url: url }).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(txt + ' ' + url); this.textContent = '\u2713 Lien copi\u00e9'; }
  };

  /* ---------- Boucle de rendu ---------- */
  var last = 0, visible = true;
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; });

  function update(dt) {
    var step = (G.run ? G.spd : 0.45) * dt;
    G.ang = norm(G.ang + G.dir * step);
    G.earth = norm(G.earth + 0.22 * dt);
    if (G.run) {
      G.travel += step;
      if (G.hits >= 15) { G.tc = norm(G.tc - G.dir * 0.22 * dt); }
      if (G.travel > TAU * 2) { miss('Message perdu'); }
    }
    var p = mPos();
    G.trail.push({ x: p.x, y: p.y });
    if (G.trail.length > 22) { G.trail.shift(); }
    var i, q;
    for (i = G.parts.length - 1; i >= 0; i--) {
      q = G.parts[i]; q.x += q.vx * dt; q.y += q.vy * dt; q.vx *= 0.96; q.vy *= 0.96; q.l -= dt * 1.2;
      if (q.l <= 0) { G.parts.splice(i, 1); }
    }
    for (i = G.rings.length - 1; i >= 0; i--) {
      q = G.rings[i]; q.r += 120 * dt; q.l -= dt * 1.8;
      if (q.l <= 0) { G.rings.splice(i, 1); }
    }
    G.shake = Math.max(0, G.shake - dt * 3);
    G.flash = Math.max(0, G.flash - dt * 1.6);
    G.msgT = Math.max(0, G.msgT - dt);
  }

  function draw(t) {
    var rxMode = G.dir < 0, i, s, g;
    ctx.save();
    ctx.clearRect(0, 0, W, W);
    if (G.shake > 0) { ctx.translate((Math.random() - 0.5) * 10 * G.shake, (Math.random() - 0.5) * 10 * G.shake); }

    /* fond */
    g = ctx.createRadialGradient(cx, cy, 10, cx, cy, W * 0.72);
    g.addColorStop(0, rxMode ? '#3b1a52' : '#221a5c');
    g.addColorStop(1, rxMode ? '#12061c' : '#070517');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);

    /* \u00e9toiles */
    for (i = 0; i < stars.length; i++) {
      s = stars[i];
      ctx.globalAlpha = 0.35 + 0.65 * Math.abs(Math.sin(t / 900 + s.t));
      ctx.fillStyle = '#ffffff';
      ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, TAU); ctx.fill();
    }
    ctx.globalAlpha = 1;

    /* orbite Terre */
    ctx.setLineDash([3, 6]);
    ctx.strokeStyle = 'rgba(159,180,240,.22)'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.arc(cx, cy, R * 1.36, 0, TAU); ctx.stroke();
    ctx.setLineDash([]);

    /* orbite Mercure */
    ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.arc(cx, cy, R, 0, TAU); ctx.stroke();

    /* arc cible */
    if (G.run) {
      var pulse = 0.6 + 0.4 * Math.sin(t / 180);
      ctx.lineCap = 'round';
      ctx.shadowColor = 'rgba(243,210,122,.9)'; ctx.shadowBlur = 18 * pulse;
      ctx.strokeStyle = 'rgba(243,210,122,' + (0.55 + 0.35 * pulse) + ')'; ctx.lineWidth = 16;
      ctx.beginPath(); ctx.arc(cx, cy, R, G.tc - G.hw, G.tc + G.hw); ctx.stroke();
      ctx.shadowBlur = 0;
      ctx.strokeStyle = 'rgba(255,255,255,.85)'; ctx.lineWidth = 5;
      ctx.beginPath(); ctx.arc(cx, cy, R, G.tc - G.hw * 0.33, G.tc + G.hw * 0.33); ctx.stroke();
      ctx.lineCap = 'butt';
      /* jauge de temps restant */
      var left = Math.max(0, 1 - G.travel / (TAU * 2));
      ctx.strokeStyle = 'rgba(143,107,255,.55)'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.arc(cx, cy, R * 0.62, -Math.PI / 2, -Math.PI / 2 + TAU * left); ctx.stroke();
    }

    /* Soleil */
    g = ctx.createRadialGradient(cx, cy, 2, cx, cy, W * 0.13);
    g.addColorStop(0, '#fffbe6'); g.addColorStop(0.35, '#f7d26b'); g.addColorStop(0.7, 'rgba(247,160,60,.35)'); g.addColorStop(1, 'rgba(247,160,60,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(cx, cy, W * 0.13, 0, TAU); ctx.fill();

    /* Terre */
    var ex = cx + Math.cos(G.earth) * R * 1.36, ey = cy + Math.sin(G.earth) * R * 1.36;
    g = ctx.createRadialGradient(ex - 2, ey - 2, 1, ex, ey, 8);
    g.addColorStop(0, '#bfe9ff'); g.addColorStop(1, '#2d6fd6');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(ex, ey, 6, 0, TAU); ctx.fill();

    /* tra\u00een\u00e9e */
    for (i = 0; i < G.trail.length; i++) {
      var a = i / G.trail.length;
      ctx.fillStyle = rxMode ? 'rgba(255,122,160,' + (a * 0.45) + ')' : 'rgba(127,227,213,' + (a * 0.45) + ')';
      ctx.beginPath(); ctx.arc(G.trail[i].x, G.trail[i].y, 2 + a * 5, 0, TAU); ctx.fill();
    }

    /* Mercure */
    var m = mPos();
    ctx.shadowColor = rxMode ? 'rgba(255,122,160,.9)' : 'rgba(127,227,213,.9)'; ctx.shadowBlur = 18;
    g = ctx.createRadialGradient(m.x - 3, m.y - 3, 1, m.x, m.y, 11);
    g.addColorStop(0, '#ffffff'); g.addColorStop(0.5, '#cfd8e6'); g.addColorStop(1, '#7c8aa3');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(m.x, m.y, 10, 0, TAU); ctx.fill();
    ctx.shadowBlur = 0;

    /* anneaux & particules */
    for (i = 0; i < G.rings.length; i++) {
      ctx.strokeStyle = 'rgba(243,210,122,' + G.rings[i].l + ')'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.arc(G.rings[i].x, G.rings[i].y, G.rings[i].r, 0, TAU); ctx.stroke();
    }
    for (i = 0; i < G.parts.length; i++) {
      s = G.parts[i];
      ctx.fillStyle = 'rgba(' + s.c + ',' + Math.max(0, s.l) + ')';
      ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, TAU); ctx.fill();
    }

    /* flash r\u00e9trograde */
    if (G.flash > 0) {
      ctx.fillStyle = 'rgba(226,85,122,' + (G.flash * 0.35) + ')';
      ctx.fillRect(0, 0, W, W);
    }

    /* textes */
    ctx.textAlign = 'center';
    if (G.run && rxMode) {
      ctx.font = '600 12px Poppins, Arial, sans-serif';
      ctx.fillStyle = 'rgba(255,170,195,.95)';
      ctx.fillText('\u263F Rx \u00b7 sens invers\u00e9', cx, cy + W * 0.2);
    }
    if (G.msgT > 0 && G.msg) {
      ctx.globalAlpha = Math.min(1, G.msgT * 1.5);
      ctx.font = '700 ' + Math.round(W * 0.065) + 'px "El Messiri", Georgia, serif';
      ctx.fillStyle = '#ffffff';
      ctx.shadowColor = 'rgba(0,0,0,.6)'; ctx.shadowBlur = 8;
      ctx.fillText(G.msg, cx, cy - W * 0.17 - (1.3 - G.msgT) * 14);
      ctx.shadowBlur = 0; ctx.globalAlpha = 1;
    }
    if (G.run) {
      ctx.font = '700 ' + Math.round(W * 0.09) + 'px Poppins, Arial, sans-serif';
      ctx.fillStyle = 'rgba(36,26,5,.85)';
      ctx.fillText(G.score, cx, cy + W * 0.03);
    }
    ctx.restore();
  }

  function loop(t) {
    if (!last) { last = t; }
    var dt = Math.min(0.05, (t - last) / 1000);
    last = t;
    if (visible) { update(dt); draw(t); }
    window.requestAnimationFrame(loop);
  }
  window.requestAnimationFrame(loop);
})();
} catch(error){console.error(error);}